import { Link } from 'react-router-dom';
import { useState, useEffect, useRef } from 'react';

export default function Navbar() {
  const [isApplyDropdownOpen, setIsApplyDropdownOpen] = useState(false);

  const applyDropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (applyDropdownRef.current && !applyDropdownRef.current.contains(event.target as Node)) {
        setIsApplyDropdownOpen(false);
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <header className="bg-white shadow-sm">
      <div className="container mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <Link to="/" className="inline-block">
            <img src="https://static.readdy.ai/image/10053dadbce1851b7032d4a2f38526c3/83173065781489fd4e90ffc998d6a3d9.jfif" 
                 alt="Baainearme" 
                 className="h-10" />
          </Link>
          
          <nav className="flex items-center">
            {/* Apply Now Dropdown - Only navigation item */}
            <div className="relative" ref={applyDropdownRef}>
              <button 
                onClick={() => setIsApplyDropdownOpen(!isApplyDropdownOpen)}
                className="flex items-center bg-purple-600 text-white px-6 py-2 rounded-full font-semibold hover:bg-purple-700 transition-colors cursor-pointer whitespace-nowrap"
              >
                Action
                <i className={`ri-arrow-down-s-line ml-1 transition-transform ${isApplyDropdownOpen ? 'rotate-180' : ''}`}></i>
              </button>
              
              {isApplyDropdownOpen && (
                <div className="absolute right-0 mt-2 w-64 bg-white rounded-lg shadow-lg border border-gray-100 z-50">
                  <div className="py-2">
                    <div className="px-4 py-2 text-xs font-semibold text-gray-500 uppercase">For Customers</div>
                    <Link to="/customer" className="block px-4 py-2 text-gray-700 hover:bg-purple-50 hover:text-purple-600 cursor-pointer">
                      <i className="ri-search-line mr-2"></i>
                      Book a Service
                    </Link>
                   <div className="px-4 py-2">
  <div className="text-gray-700 text-sm mb-2 flex items-center">
    <i className="ri-smartphone-line mr-2"></i>
    Download Customer App
  </div>

  <div className="flex gap-2">
    <a
      href="https://play.google.com/store/apps/details?id=com.baainearme.customerapp"
      target="_blank"
      rel="noopener noreferrer"
      className="bg-black text-white px-3 py-1 rounded text-xs hover:bg-gray-800 transition-colors cursor-pointer flex items-center"
    >
      <i className="ri-google-play-fill mr-1"></i>
      Android
    </a>

    <a
      href="https://apps.apple.com/app/bnm/id6751604989"
      target="_blank"
      rel="noopener noreferrer"
      className="bg-black text-white px-3 py-1 rounded text-xs hover:bg-gray-800 transition-colors cursor-pointer flex items-center"
    >
      <i className="ri-app-store-fill mr-1"></i>
      iOS
    </a>
  </div>
</div>

                    <div className="border-t border-gray-100 my-2"></div>
                    
                    <div className="px-4 py-2 text-xs font-semibold text-gray-500 uppercase">For Partners</div>
                    <Link to="/partner#earnings" className="block px-4 py-2 text-gray-700 hover:bg-purple-50 hover:text-purple-600 cursor-pointer">
                      <i className="ri-money-rupee-circle-line mr-2"></i>
                      View Earning Potential
                    </Link>
                    <Link to="/apply" className="block px-4 py-2 text-gray-700 hover:bg-purple-50 hover:text-purple-600 cursor-pointer">
                      <i className="ri-user-add-line mr-2"></i>
                      Apply Now
                    </Link>
                    
                    <div className="border-t border-gray-100 my-2"></div>
                    
                    <div className="px-4 py-2 text-xs font-semibold text-gray-500 uppercase">Contact</div>
                    <a href="tel:93074 19845" className="block px-4 py-2 text-gray-700 hover:bg-purple-50 hover:text-purple-600 cursor-pointer">
                      <i className="ri-phone-line mr-2"></i>
                      Call: 93074 19845
                    </a>
                    <a href="mailto:support@baainearme.com" className="block px-4 py-2 text-gray-700 hover:bg-purple-50 hover:text-purple-600 cursor-pointer">
                      <i className="ri-mail-line mr-2"></i>
                      Email Support
                    </a>
                  </div>
                </div>
              )}
            </div>
          </nav>
        </div>
      </div>
    </header>
  );
}
